import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    pageTitle: ''
}

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload
        },
        clearPageTitle: (state) => {
            state.pageTitle = ''
        }
    }
})

export const { setPageTitle, clearPageTitle } = navigationSlice.actions
export default navigationSlice.reducer
